import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DataTablesModule } from "angular-datatables";
import { CKEditorModule } from 'ckeditor4-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgxMaskModule } from 'ngx-mask';
import { ValdemortConfig, ValdemortModule } from 'ngx-valdemort';
import { DirectivesModule } from "../core/directives/directives.module";
import { PipesModule } from "../core/pipes/pipes.module";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { CustomDatePickerComponent } from "./components/custom-date-picker/custom-date-picker.component";
import { DataWarehouseComponent } from "./components/data-warehouse/data-warehouse.component";
import { ExcelTypeFilterComponent } from './components/excel-type-filter/excel-type-filter.component';
import { LSFileUploadComponent } from "./components/file-upload/file-upload.component";
import { LSNodataFoundComponent } from "./components/nodata-found/nodata-found.component";
import { OtpModalComponent } from './components/otp-modal/otp-modal.component';
import { PixelEditorComponent } from "./components/pixel-editor/pixel-editor.component";
import { LSSearchFilterComponent } from "./components/search-filter/search-filter.component";
import { LSSearchInputComponent } from "./components/search-input/search-input.component";
import { LSUploadFileParserComponent } from "./components/upload-file-parser/upload-file-parser.component";
import { MaterialWidgetModule } from "./modules/materialwidget/materialwidget.module";
import { CustomADateAdapter } from "./services/custom-date-adapter.service";
import { CustomDateParserFormatter } from "./services/custom-date-parser.service";

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    MaterialWidgetModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    ValdemortModule,
    DirectivesModule,
    NgbModule,
    PipesModule,
    NgApexchartsModule,
    DataTablesModule,
    NgxExtendedPdfViewerModule,
    NgSelectModule,
    HttpClientModule,
    NgbPopoverModule,
    MatListModule,
    MatIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatTooltipModule,
    NgOtpInputModule ,
    NgxMaskModule
  ],
  declarations: [
    ConfirmModalComponent,
    LSFileUploadComponent,
    LSSearchFilterComponent,
    LSSearchInputComponent,
    LSNodataFoundComponent,
    DataWarehouseComponent,
    LSUploadFileParserComponent,
    CustomDatePickerComponent,
    PixelEditorComponent,
    ExcelTypeFilterComponent,
    OtpModalComponent
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomADateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ],
  exports: [
    MaterialWidgetModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    ValdemortModule,
    DirectivesModule,
    ConfirmModalComponent,
    LSFileUploadComponent,
    LSSearchFilterComponent,
    LSSearchInputComponent,
    LSNodataFoundComponent,
    NgbModule,
    PipesModule,
    NgApexchartsModule,
    DataTablesModule,
    DataWarehouseComponent,
    LSUploadFileParserComponent,
    NgxExtendedPdfViewerModule,
    CustomDatePickerComponent,
    NgSelectModule,
    PixelEditorComponent,
    ExcelTypeFilterComponent,
    NgOtpInputModule,
    NgxMaskModule
  ]
})
export class SharedModule {
  constructor(config: ValdemortConfig) {
    config.errorsClasses = 'text-danger';
  }
}
